import React from "react";


import Iframe from 'react-iframe'

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {

  const classes = useStyles();
  return (
    <div>
      <Iframe url={props.iframeUrl}
        width="100%"
        height="100%"
        id="myId"
        className={classes.dashboardCard}
        display="initial"
        position="relative"/>
    </div>
  );
}
